export const USER_STATUS = {
  NEW: 'new',
  CONTINUE: 'continue',
  PATIENT: 'patient'
}
